import React, { useState } from "react";
import * as styles from "/src/css/projects.module.css";
import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import { graphql, useStaticQuery } from "gatsby";
import ProjectSummary from "/src/components/Project/ProjectSummary";
import { v4 as uuidv4 } from "uuid";
import Slideshow from "/src/components/Project/Slideshow";

const ProjectsPage = () => {
  const [category, setCategory] = useState("Corporates");
  const data = useStaticQuery(query);

  return (
    <>
      <Seo title="Projects" />
      <div className={styles.projects}>
        <div>
          <div>
            <Slideshow />
          </div>
        </div>
        <div className={styles.bottomSection}>
          <div className={styles.categories}>
            <div>
              <div className={styles.catheader}>
                <h1>Choose Your Category</h1>
                <div className={styles.linebreak}>
                  <hr />
                </div>
              </div>
            </div>
            <div className={styles.categoriesBody}>
              <button
                className={`${styles.categoriesTypes} ${
                  category === "Corporates" ? styles.active : null
                }`}
                onClick={() => setCategory("Corporates")}
              >
                Corporates
              </button>

              <button
                className={`${styles.categoriesTypes} ${
                  category === "Individuals" ? styles.active : null
                }`}
                onClick={() => setCategory("Individuals")}
              >
                Individuals
              </button>

              <button
                className={`${styles.categoriesTypes} ${
                  category === "Schools" ? styles.active : null
                }`}
                onClick={() => setCategory("Schools")}
              >
                Schools
              </button>
            </div>
          </div>

          <div>
            <div className={styles.projectlist}>
              {data.allContentfulProject.edges.map((edge) => {
                return (
                  <div key={uuidv4()}>
                    {edge.node.category.toString() === category ? (
                      <ProjectSummary data={edge} />
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const query = graphql`
  query MyQuery {
    allContentfulProject {
      edges {
        node {
          category
          createdAt(formatString: "MMMM Do, YYYY")
          title
          summary
          isTakingVolunteers
          summary
          description {
            raw
          }
          images {
            description
            gatsbyImageData(layout: CONSTRAINED, placeholder: TRACED_SVG)
          }
        }
      }
    }
  }
`;
ProjectsPage.Layout = Layout;
export default ProjectsPage;
